var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home-preview"}},[_c('h1',[_c('TextScrambleEffect',[_vm._v("Кібербезпека")])],1),_c('p',[_vm._v("Факультет комп'ютерних інформаційних технологій")])])
}
var staticRenderFns = []

export { render, staticRenderFns }